import React from 'react';
import {
  ELEMENT_MEDIA_EMBED,
  useMediaStore,
  offset,
  flip,
  shift,
} from '@udecode/plate';
import { useReadOnly } from 'slate-react';

import { CaptionRoot, CaptionTextarea } from '../caption/Caption';
import { PlateFloatingMedia } from '../PlateFloatingMedia';
import { ElementPopover } from '../../../components/popup/Floating/ElementPopover';
import { Media } from '../Media';

import './embed.scss';

const providersPadding = {
  youtube: '56.2061%',
  vimeo: '56.25%',
  youku: '56.25%',
  dailymotion: '56.0417%',
  coub: '51.25%',
  youtubeShorts: '177.78%',
};

export const MediaEmbedElement = (props) => {
  const {
    children,
    nodeProps,
    element,
    caption = {},
    popoverProps = {},
  } = props;

  const { as, ...rootProps } = props;

  const { align = 'left' } = element || {};

  const readOnly = useReadOnly();

  const { provider } = useMediaStore().get.urlData();
  const providerPadding =
  provider !== 'twitter'
    ? (provider && providersPadding[provider]) || '56.0417%'
    : undefined;

  return (
    <Media.Root {...rootProps}>
      <figure
        className="slate-ui-media"
        contentEditable={false}
      >
        <Media.Resizable
          // @ts-ignore
          className="slate-ui-media__resize"
          maxWidth={provider === 'twitter' ? 550 : '100%'}
          minWidth={provider === 'twitter' ? 300 : 100}
          renderHandleLeft={(htmlProps) => (
            <div
              {...htmlProps}
              className="slate-ui-media__resize-handle slate-ui-media__resize-handle--left"
            />
          )}
          renderHandleRight={(htmlProps) => (
            <div
              {...htmlProps}
              className="slate-ui-media__resize-handle slate-ui-media__resize-handle--right"
            />
          )}
          align={align}
        >
          <ElementPopover
            content={<PlateFloatingMedia pluginKey={ELEMENT_MEDIA_EMBED} />}
            floatingOptions={{
              middleware: [
                offset(10),
                flip({ padding: 96 }),
                shift(),
              ],
              placement: 'bottom',
            }}
            {...popoverProps}
          >
            <div
              className="slate-embed"
              style={{ paddingBottom: providerPadding }}
            >
              <MediaEmbed
                className="slate-embed__iframe"
                {...nodeProps}
              />
            </div>
          </ElementPopover>
        </Media.Resizable>

        {!caption.disabled && (
          <CaptionRoot
            className="slate-ui-media__caption"
          >
            <CaptionTextarea
              placeholder={caption.placeholder ?? 'Write a caption...'}
              readOnly={(readOnly) || !!caption.readOnly}
            />
          </CaptionRoot>
        )}
      </figure>

      {children}
    </Media.Root>
  );
};

export const MediaEmbed = (props) => {
  const { component: Component, ...embedData } = useMediaStore().get.urlData();
  if (!Component) return null;

  return (
    <Component
      {...embedData}
      {...props}
    />
  );
};
